import { memo } from "react";

interface Props {
  text: string;
  maxLength: number;
}

// https://gist.github.com/jonlabelle/5375315

export function truncate(
  str: string,
  maxChars: number,
  append?: string,
  onlyFullWords?: boolean
) {
  append = append || "...";
  maxChars = onlyFullWords ? maxChars + 1 : maxChars;

  str = str.trim();
  if (str.length <= maxChars) {
    return str;
  }
  str = str.substr(0, maxChars - append.length);
  //crop at last space or remove trailing whitespace
  str = onlyFullWords ? str.substr(0, str.lastIndexOf(" ")) : str.trim();
  return str + append;
}

function TruncatedText({ text, maxLength }: Props) {
  return <>{truncate(text, maxLength)}</>;
}

export default memo(TruncatedText);
